import React from 'react';
import { Lock } from 'lucide-react';
import { TrackerLayout } from './TrackerLayout';
import { CARD, dateShort, dateTime } from './trackerApi';

export default function TrackerSettings() {
  return (
    <TrackerLayout title="Settings" subtitle="Your tracked brand and competitors. Managed by your Vyvre team.">
      {(a) => (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5" data-testid="tracker-settings">
          <div className={`${CARD} p-6`}>
            <div className="text-xs font-semibold uppercase tracking-[0.08em] text-[#71717A] mb-2">Brand</div>
            <div className="text-2xl font-bold" data-testid="settings-brand-name">{a.brand_name}</div>
            <div className="text-xs text-[#71717A] mt-3">Data last updated {dateTime(a.last_scraped_at)}</div>
          </div>
          <div className={`${CARD} p-6 lg:col-span-2`}>
            <div className="flex items-center justify-between mb-4">
              <div className="text-xs font-semibold uppercase tracking-[0.08em] text-[#71717A]">Tracked competitors ({a.competitors.length})</div>
              <span className="inline-flex items-center gap-1 text-[11px] text-[#A1A1AA]"><Lock size={11} /> Read only — contact your account manager to change</span>
            </div>
            <div className="divide-y divide-black/[0.05]" data-testid="settings-competitors">
              {a.competitors.map((c) => (
                <div key={c.instagram_handle} className="py-3 flex items-center justify-between" data-testid={`settings-competitor-${c.instagram_handle}`}>
                  <div><div className="font-semibold">{c.name}</div><div className="text-xs text-[#FF451A]">@{c.instagram_handle}{(c.hashtag || c.discovered_hashtags?.length > 0) && <span className="text-[#6B6B6B]"> · {c.hashtag ? `#${c.hashtag}` : c.discovered_hashtags.map((t) => `#${t}`).join(' ')}</span>}</div></div>
                  <div className="text-xs text-[#71717A]">Tracking since {dateShort(c.added_at)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </TrackerLayout>
  );
}
